import {html, css, LitElement, ref, createRef} from 'lit';

function wrap(number, min, max) {
  const range = max - min + 1;
  return ((number - min) % range + range) % range + min;
}


export class DzCarousel extends LitElement {
  $box = createRef()

  static properties = {
    duration: { type: Number },
    period: { type: Number },
    showControls: {type: Boolean }
  }
      
  constructor() {
    super();
    this.page = 0    
    this.duration = 1
    this.showControls = false

    this.children[0].setAttribute("slot", "first")
    this.children[1].setAttribute("slot", "second")
  }

  connectedCallback() {
    super.connectedCallback()
      setInterval(() => this.slideNext(), parseInt(this.period) * 1000)
  }

  render() {
    return html`
        <div class="box" ${ref(this.$box)}>
          <slot name="first"></slot>
          <slot name="second"></slot>
        </div>
    `;
  }

  slideNext() {
      if (this.busy) return

      let box = this.$box.value
      let mod = this.children.length - 1
      box.style.animation = `slideleft ${this.duration}s ease-out`
      
      this.busy = true
      box.addEventListener("animationend", evt => {
        box.style.animation = ``
        this.children[this.page].setAttribute("slot", "")   
        this.page = wrap(this.page + 1, 0, mod)
        this.children[this.page].setAttribute("slot", "first")
        this.children[wrap(this.page + 1, 0, mod)].setAttribute("slot", "second")
        this.busy = false
      }, {once: true})
  }

  slideBack() {
      if (this.busy) return

      let box = this.$box.value
      let mod = this.children.length - 1
      
      this.children[this.page].setAttribute("slot", "second")
      this.children[wrap(this.page + 1, 0, mod)].setAttribute("slot", "")   
      this.page = wrap(this.page - 1, 0, mod)    
      this.children[this.page].setAttribute("slot", "first")
      
      box.style.animation = `slideright ${this.duration}s ease-out` 
      
      this.busy = true
      box.addEventListener("animationend", evt => {
        box.style.animation = ``
        this.busy = false
      }, {once: true})
  }

  static styles = css`
      :host {
        position: relative;
      }
      
      .box {
        position: absolute;
        width: 200%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr)
      }
        
      @keyframes slideleft {
        0% {
          left: 0%;
        }
        100% {
          left: -100%;
        }
      }
      
      @keyframes slideright {
        0% {
          left: -100%;
        }
        100% {
          left: 0%;
        }
      } 
  `
}
customElements.define('dz-carousel', DzCarousel);